import { render, staticRenderFns } from "./Guest.vue?vue&type=template&id=22e474a6&scoped=true&"
import script from "./Guest.vue?vue&type=script&lang=ts&"
export * from "./Guest.vue?vue&type=script&lang=ts&"
import style0 from "./Guest.vue?vue&type=style&index=0&id=22e474a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e474a6",
  null
  
)

export default component.exports